<template>
    <div>
        <div v-if="show" class="modal-shadow" @click.self="closeModal">
            <div class="modal" style="position: fixed; z-index: 1;">
                <div class="modal-close" @click="closeModal">&#10006;</div>
                <div name="body">
                  <template v-if="type === 1">
                    <div class="modal-content">
                        {{localizeList.loadAnotherAirTariffPart1Upper}} {{getTariffStringByKey(tariffP)}} {{localizeList.loadAnotherAirTariffPart2Upper}}
                    </div>
                        <div class="filter class-filter" style="margin-left:20px;">
                            <h3 class="filter-name headline mb-10">{{localizeList.flightClass}}</h3>
                            <div class="filter-list">
                                <div v-for="(item, key) in classItems"
                                        :key="key"
                                        class="filter-item mb-6">
                                    <radio-btn :value="item.isChecked"
                                    @change="changeClass(key)">
                                        {{getTariffStringByKey(item.value)}}
                                    </radio-btn>
                                </div>
                            </div>
                        </div>
                  </template>
                  <template v-else-if="type === 2">
                    <div class="modal-content">
                        {{getStringToModal}}
                    </div>
                  </template>
                </div>
                <div name="footer">
                    <div v-if="type === 1" class="modal-footer">
                        <base-button class="modal-footer-button" @click="newTariffSearchClick">
                          {{localizeList.find}}
                        </base-button>
                    </div>
                    <div v-else-if="type === 2" class="modal-footer">
                          <div  v-if="useOkButton" class="buttons-container">
                            <base-button minWidth="75"
                                         @click="eventModal('yes')">
                              {{localizeList.okUpper}}
                            </base-button>
                          </div>
                          <div v-else class="buttons-container">
                            <base-button minWidth="75"
                                         @click="eventModal('yes')">
                              {{localizeList.yesUpper}}
                            </base-button>
                            <base-button minWidth="75"
                                         @click="eventModal('no')">
                              {{localizeList.noUpper}}
                            </base-button>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: "load-another-air-tariff",
        data()
        {
            return{
                show:false,
                classItems: [
                    {
                        isChecked: true,
                        value: "economy"
                    },
                    {
                        isChecked: false,
                        value: "premiumEconomy"
                    },
                    {
                        isChecked: false,
                        value: "business"
                    },
                    {
                        isChecked: false,
                        value: "first"
                    }
                ],
            }
        },
        props: {
            showP:{
                type:Boolean,
                default:false
            },
            tariffP:{
                type:String,
                default: "economy"
            },
            type:{
                type: Number,
                default: 1
            },
            flightData: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            useOkButton() {
              return this.flightData[1].mode === 'increase' ? true : false;
            },
            getStringToModal() {
              const mode = this.flightData[1].mode;
              const days = this.flightData[1].differenceInDays;
              let text = '';
              if (mode === 'decrease') {
                 text = this.localizeList.decreaseDurationOfResidence.replace('{0}', days).replace('{1}', this.getDayLocal(days, 'night'));
              } else if (mode === 'increase') {
                 text = this.localizeList.increaseDurationOfResidence.replace('{0}', days).replace('{1}', this.getDayLocal(days, 'night'));
              }

              return text;
            }
        },
        methods: {
            getDayLocal(day, type) {
                if (day === 1) {
                    return this.localizeList[type]
                } else if (day < 5 && day > 1) {
                    return this.localizeList[type+"2"]
                } else {
                    return this.localizeList[type+"s"]
                }
            },
            eventModal(value) {
              this.$emit('eventModal', [value, ...this.flightData]);
              this.closeModal();
            },
            closeModal() {
                this.show = false,
                this.$emit('closeModal')
            },
            getTariffStringByKey(key){
                switch(key)
                {
                    case 'economy':
                        {
                            return this.localizeList.economyUpper;
                        }
                    case 'premiumEconomy':
                        {
                            return this.localizeList.premiumEconomyUpper;
                        }
                    case 'business':
                        {
                            return this.localizeList.businnessUpper;
                        }
                    case 'first':
                        {
                            return this.localizeList.firstUpper;
                        }
                }
            },
            changeClass(key) {
                this.classItems = this.classItems.map((x, i) => {
                    x.isChecked = i === key;
                    return x
                });
            },
            newTariffSearchClick(){
                var item = this.classItems.find(x=>x.isChecked===true);
                this.$emit('searchByChangedTariff',item.value);
                this.show = false,
                this.$emit('closeModal')
            },
        },
        watch:{
            showP(newValue)
            {
                this.show = newValue;
            },
        }
    }
</script>
 
<style scoped>
    .modal-shadow {
        position: fixed;
        top: 0;
        left: 0;
        min-height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.39);
    }
 
    .modal {
        background: #fff;
        border-radius: 8px;
        padding: 15px;
        min-width: 420px;
        max-width: 520px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
 
    }
    .modal-footer-button{
        width: 30%;
        margin-left: auto;
    }
    .modal-close{
        border-radius: 50%;
            color: #000000;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 7px;
            right: 7px;
            width: 30px;
            height: 30px;
            cursor: pointer;
            font-weight: bold;
    }
    .modal-content{
        margin: 20px 20px 20px 20px;
    }
    .buttons-container {
        display: flex;
        gap: 10px;
        justify-content: center;
    }
</style>